import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceBoardsOrganizationFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { boardCounts: Array<(
    { __typename: 'Organization_BoardCounts' }
    & Pick<Types.Organization_BoardCounts, 'boardCount' | 'idMember'>
  )>, memberships: Array<(
    { __typename: 'Organization_Membership' }
    & Pick<Types.Organization_Membership, 'id' | 'idMember' | 'memberType'>
  )> }
);

export const WorkspaceBoardsOrganizationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceBoardsOrganization' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boardCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boardCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idMember' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'memberships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceBoardsOrganizationFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceBoardsOrganizationFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceBoardsOrganizationFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceBoardsOrganizationFragment>,
    'data'
  > {
  data?: WorkspaceBoardsOrganizationFragment;
}

export const useWorkspaceBoardsOrganizationFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceBoardsOrganizationFragmentOptions): UseWorkspaceBoardsOrganizationFragmentResult => {
  const result = Apollo.useFragment<WorkspaceBoardsOrganizationFragment>({
    ...options,
    fragment: WorkspaceBoardsOrganizationFragmentDoc,
    fragmentName: 'WorkspaceBoardsOrganization',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as WorkspaceBoardsOrganizationFragment,
  };
};
